import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { buildWorldSeoPage } from './worldExplorerSeo';
import './WorldExplorerPublicPage.css';

export default function WorldExplorerSeoPage({ kind }) {
  const params = useParams();
  const page = buildWorldSeoPage(kind, params);
  React.useEffect(() => {
    if (!page) return undefined;
    const previous = document.title;
    document.title = `${page.title} | World Explorer`;
    return () => { document.title = previous; };
  }, [page]);
  if (!page) return <main className="we-public we-public__seo"><h1>World page not found</h1><Link to="/world-explorer">Return to World Explorer</Link></main>;
  const schema = { '@context': 'https://schema.org', '@type': page.answer ? 'FAQPage' : 'WebPage', name: page.title, description: page.description };
  return <main className="we-public we-public__seo">
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
    <p className="we-public__eyebrow">WORLD EXPLORER · SOURCED REFERENCE</p>
    <h1>{page.title}</h1>
    <p className="we-public__lead">{page.answer || page.description}</p>
    <section className="we-public__seo-grid">{page.places.map((place) => <article key={place.name}><h2>{place.name}</h2><p>{place.kind}{place.continent ? ` · ${place.continent}` : ''}</p><p>Capital: {place.capital || 'unknown'}</p><p>ISO: {place.iso || 'unknown'}</p><small>Source: {place.source}. Recheck the live product for population years, observation dates and conflicts.</small></article>)}</section>
    <p>These public pages expose only reviewed, source-backed fields. They do not publish precise coordinates or infer missing figures, and population years and definitions live in the full product.</p>
    <Link className="we-public__primary" to="/world-explorer">Explore the full product</Link>
  </main>;
}
